<script lang="ts">
    import type { InstagramBlockFragment } from '$gen/graphql';
    import { localStore } from '$lib/privacy-banner/localStore';
    import { routes } from '$lib/routes';

    export let instaPosts: InstagramBlockFragment;
</script>

<section class="grid grid-cols-1 gap-5 md:min-h-[70vh] md:grid-cols-2">
    {#each instaPosts.embedCodes as post}
        {#if $localStore.instaEmbed === 'allowed'}
            <article class="grid min-h-full w-full place-content-center">
                {@html post.embedCode}
            </article>
        {:else if $localStore.instaEmbed === 'not_yet_asked' || $localStore.instaEmbed === 'forbidden'}
            <article class="grid min-h-full w-full place-content-center">
                <div class="w-full space-y-20 rounded-[4em] bg-[#ff3800] p-12">
                    <div class="text-2xl">
                        <p class="">Allow embedded Instagram posts?</p>
                        <div class="w-full">
                            <button
                                class="ml-[60%] mr-5"
                                on:click={() => ($localStore.instaEmbed = 'allowed')}>Yes</button
                            >
                        </div>
                    </div>
                    <p class="">
                        This can be changed at any time on the <a
                            class="underline"
                            href={routes.privacyPolicy}>privacy page</a
                        >.
                    </p>
                </div>
            </article>
        {/if}
    {/each}
</section>
